import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useRouteMatch, Link } from 'react-router-dom'
import { IconHyperlink } from '@offerzen/pinata-shame'
import ChevronLeftIcon from '@offerzen/zenicon/ChevronLeftIcon'

import Breadcrumb from '@/CandidateExperience/components/Breadcrumb'
import { previousLocation } from '@/CandidateExperience/selectors/router'

import styles from './styles'

const createBreadcrumb = ({ candidateSlug, locationState, history }) => {
  const breadcrumbLabel = locationState?.includes('applications') ? 'Applications' : 'Available jobs'
  const href = locationState ?? `/candidate/${candidateSlug}/jobs`
  const goBack = e => {
    if (locationState) {
      e.preventDefault()
      history.goBack()
    }
  }

  return [
    {
      label: (
        <IconHyperlink
          label={breadcrumbLabel}
          icon={ChevronLeftIcon}
          withBackground={false}
          size="medium"
          href={href}
          as={Link}
          onClick={e => goBack(e)}
        />
      ),
    },
  ]
}

const DetailsBreadcrumb = () => {
  const {
    params: { candidateSlug },
  } = useRouteMatch()
  const history = useHistory()
  const locationState = useSelector(previousLocation)

  return <Breadcrumb path={createBreadcrumb({ candidateSlug, locationState, history })} className={styles.breadcrumbs} />
}

export default DetailsBreadcrumb
